import { render } from "./PVTPrediction.vue?vue&type=template&id=28583f6a&scoped=true"
import script from "./PVTPrediction.vue?vue&type=script&lang=js"
export * from "./PVTPrediction.vue?vue&type=script&lang=js"

import "./PVTPrediction.vue?vue&type=style&index=0&id=28583f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28583f6a"]])

export default __exports__